export default "__VITE_ASSET__BFm7HGIo__"